<div class="container">
  <p class="headline">Everything you need for the day of</p>
  <p class="tagline">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua.
  </p>
</div>
